module.exports = __webpack_public_path__ + "static/img/organism-h5-6.dae2b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-6.png
// module id = /Hb5
// module chunks = 34